import DeviceLog from '@/services/api/device-log';

export default {
  state: {
    deviceLog: [],
    deviceLogs: [],
  },
  getters: {
    deviceLog: state => state.deviceLog,
    deviceLogs: state => state.deviceLog,
  },
  mutations: {
    setDeviceLog: (state, payload) => {
      state.deviceLog = payload.data;
    },
    deviceLogs: (state, payload) => {
      state.deviceLogs = payload.data;
    },
  },
  actions: {
    getDeviceLogKeys (state, id) {
      return new Promise((resolve, reject) => {
        DeviceLog.getDeviceLogKeys(id)
          .then((data) => {
            state.commit('setDeviceLog', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceLogs (state, id) {
      return new Promise((resolve, reject) => {
        DeviceLog.getDeviceLogs(id)
          .then(({ data }) => {
            state.commit('deviceLogs', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getLogsNameFile (state, { nameFile }) {
      return new Promise((resolve, reject) => {
        DeviceLog.getLogsNameFile(nameFile)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
